import { type TTgbNativedescGeneralContext } from '@cian/adfox-templates';

import type { TTgbNativedescGeneralProps } from '../components/TgbNativedescGeneralNarrow';

type TGetTgbNativedescGeneralNarrowPropsParams = {
  context: TTgbNativedescGeneralContext;
};

export function getTgbNativedescGeneralNarrowProps({
  context: { url, label, image, title, annotation, description, logoImageUrl },
}: TGetTgbNativedescGeneralNarrowPropsParams): TTgbNativedescGeneralProps {
  return {
    annotation,
    description,
    image,
    label,
    logoUrl: logoImageUrl,
    title,
    url,
  };
}
